// Compatibility shim — actual implementation lives in ContactChannels.jsx so
// WhatsApp + Viber can share one source of truth for the phone number.
import { ContactFloats, WHATSAPP_URL, buildWhatsAppUrl } from "./ContactChannels";

export { WHATSAPP_URL, buildWhatsAppUrl };
export default ContactFloats;
